import { ItemCategoryService, ItemsService, UnitcodeService } from '@gtpl/shared-services/masters';
import { SaleOrderService } from '@gtpl/shared-services/sale-management';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { StoreReturnAdapter } from './dto/store-return.adapter';
import { StoreReturn } from './store-return.entity';
import { StoreReturnsController } from './store-returns.controller';
import { StoreReturnsService } from './store-returns.service';

@Module({
  imports: [
    TypeOrmModule.forFeature([StoreReturn]),
  ],
  controllers: [StoreReturnsController],
  providers: [StoreReturnsService,StoreReturnAdapter,ApplicationExceptionHandler, SaleOrderService, ItemCategoryService, ItemsService, UnitcodeService]
})
export class StoreReturnsModule {}
